
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login/[redirectUri]",
      function () {
        return require("private-next-pages/login/[redirectUri].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/login/[redirectUri]"])
      });
    }
  